import styled from "styled-components";

export const ContainerProd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 500px;

  .spinner {
    margin-top: 30vh;
  }
`;
